<template>
    <crud-facecade
        ref="surgerylog-list"
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :addButton="{ enabled: false, permission: 'default' }"
        :updateButton="{ enabled: false, permission: 'default' }"
    >
        <template slot="filter">
            <el-col :md="8" :xl="5">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
        </template>
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `SurgeryLog`,
    props: {

    },
    data() {
        return {
            title: `手术日志`,
            messageList: [],
            url: { baseURL: `/api/Preoperative/Apply/`,
                get: () => {
                    return this.ReloadListData()
                } },
            buttons: [],
            rdate: [this.$moment().add(-2, `days`).format(`YYYY/MM/DD`), this.$moment().add(1, `days`).format(`YYYY/MM/DD HH:mm:ss`)],
            users: []
        }
    },
    created() {
        this.loadUsers()
    },
    computed: {
        ...mapGetters([`sys_enums`]),
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `patient_name`,
                label: `患者姓名`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true
            },
            {
                type: `string`,
                prop: `visit_no`,
                label: `就诊号`,
                isListable: true,
                width: `180`,
                isExpand: false
            }, {
                type: `select`,
                prop: `logyype`,
                label: `类型`,
                isListable: true,
                width: `120`,
                isExpand: false,
                searchable: true,
                options: this.sys_enums.SurgeryLogType || []
            },
            {
                type: `string`,
                prop: `creator`,
                label: `操作人`,
                isListable: true,
                width: `120`,
                isExpand: false,
                config: {
                    collapseTags: false
                }
            }, {
                type: `datetime`,
                prop: `createdt`,
                label: `时间`,
                isListable: true,
                width: `180`,
                sortable: true,
                isExpand: false
            }, {
                type: `string`,
                prop: `memo`,
                label: `备注`,
                _isListable: true,
                get isListable() {
                    return this._isListable
                },
                set isListable(value) {
                    this._isListable = value
                },
                isExpand: false
            }
            ]
        }
    },
    mounted() {

    },
    methods: {
        loadUsers() {
            let req = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
            req.then((data) => {
                this.users = _.map(data, d => {
                    return {
                        value: d.id,
                        label: d.dic_worker_name || `--`,
                        code: d.username,
                        disabled: d.is_deleted
                    }
                })
            }).catch(e => {
                console.log(e)
            })
        },
        ReloadListData() {
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Preoperative/Apply/GetSurgeryInfoLog`, { begin: this.rdate[0], end: this.rdate[1] })
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        }
    },
    watch: {
        rdate: function() {
            this.$refs[`surgerylog-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Log/Index.vue